module.exports = __webpack_public_path__ + "img/battery_charging_30.10793ae4.svg";